// Tokens da seção de e-mail da configuração de propostas. O restante da página
// ainda usa classes inline (código anterior à convenção); ao mexer nas outras
// seções, migrar os tokens para cá.
export const PROPOSTAS_CONFIG_DESIGN = {
  card: 'bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-5',
  cardHeader: 'flex items-center gap-2 mb-1',
  cardIcon: 'text-[#7C3AED]',
  cardTitle: 'text-sm font-bold text-gray-900 dark:text-[#D1D2D3]',
  cardDescricao: 'text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5',

  label: 'text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-[#ABABAD]',
  input: 'mt-1.5 rounded-xl border-gray-200 dark:border-[#383838]',
  textarea:
    'mt-1.5 w-full px-3 py-2 text-sm border border-gray-200 dark:border-[#383838] rounded-xl focus:border-[#7C3AED] focus:ring-1 focus:ring-[#7C3AED]/20 focus:outline-none resize-none dark:bg-[#1A1D21] dark:text-[#D1D2D3]',
  ajuda: 'text-[11px] text-gray-400 mt-1',

  // Editor (esquerda) + pré-visualização (direita). Empilha abaixo de lg.
  emailGrid: 'grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_380px] gap-5 mt-4',
  emailForm: 'space-y-4 min-w-0',

  // Sugestão inline quando o assunto não identifica a empresa remetente.
  sugestao:
    'flex items-start gap-2 mt-2 px-2.5 py-2 rounded-lg bg-amber-50 dark:bg-amber-500/10 border border-amber-100 dark:border-amber-500/20',
  sugestaoTexto: 'text-[11px] text-amber-800 dark:text-amber-300 leading-relaxed',
  sugestaoBotao: 'text-[11px] font-semibold text-amber-900 dark:text-amber-200 underline hover:no-underline whitespace-nowrap',

  // Paleta de variáveis clicáveis
  variaveisBox: 'rounded-xl border border-violet-100 dark:border-violet-500/20 bg-violet-50/50 dark:bg-violet-500/5 p-3',
  variaveisTitulo: 'text-[11px] font-semibold text-gray-600 dark:text-[#D1D2D3] flex items-center gap-1.5',
  variaveisAjuda: 'text-[10px] text-gray-500 dark:text-[#ABABAD] mt-0.5',
  variaveisGrupo: 'mt-2.5',
  variaveisGrupoNome: 'text-[10px] font-semibold uppercase tracking-wider text-violet-400 dark:text-violet-400/70',
  variaveisLista: 'flex flex-wrap gap-1.5 mt-1',
  variavelChip:
    'px-1.5 py-1 rounded-md bg-violet-100 dark:bg-violet-500/15 text-violet-700 dark:text-violet-300 font-mono text-[10px] hover:bg-violet-200 dark:hover:bg-violet-500/25 transition-colors cursor-pointer',

  // Mockup do e-mail
  previewWrapper: 'min-w-0',
  previewJanela: 'rounded-xl border border-gray-200 dark:border-[#383838] overflow-hidden bg-white dark:bg-[#1A1D21]',
  previewBarra: 'px-3 py-2 bg-gray-50 dark:bg-[#222529] border-b border-gray-200 dark:border-[#383838] space-y-0.5',
  previewLinha: 'flex gap-1.5 text-[10px] leading-relaxed min-w-0',
  previewLinhaLabel: 'text-gray-400 flex-shrink-0 w-[42px]',
  previewLinhaValor: 'text-gray-600 dark:text-[#ABABAD] truncate',
  previewAssunto: 'text-[11px] font-semibold text-gray-900 dark:text-[#D1D2D3] break-words',
  previewCorpoFundo: 'bg-gray-100 dark:bg-[#141618] p-3',
  previewCartao: 'bg-white dark:bg-[#222529] rounded-lg overflow-hidden',
  previewEmpresa: 'text-[10px] font-bold text-[#7C3AED] uppercase tracking-wider px-4 pt-4',
  previewTexto: 'text-[11px] leading-relaxed text-gray-800 dark:text-[#D1D2D3] px-4 pt-3 whitespace-pre-wrap break-words',
  previewBotao:
    'inline-block mx-4 mt-3 px-4 py-2 bg-[#7C3AED] text-white rounded-lg text-[11px] font-semibold',
  previewLinkFallback: 'text-[10px] text-gray-500 dark:text-[#ABABAD] px-4 pt-3 pb-4 break-all',
  previewRodape:
    'text-[9px] text-gray-400 leading-relaxed px-4 py-3 border-t border-gray-100 dark:border-[#383838] bg-gray-50/70 dark:bg-[#1A1D21]',
  previewNota: 'text-[10px] text-gray-400 mt-2 flex items-start gap-1.5',
};

// Valores fictícios usados só na pré-visualização — mesmas chaves do catálogo
// devolvido por GET /propostas/variaveis. Recebe `t` para que os textos de
// exemplo fiquem traduzíveis (chamar com o `t` do namespace 'settings').
export function dadosExemploPreview(nomeEmpresa, t) {
  const hoje = new Date();
  const validade = new Date(hoje.getTime() + 15 * 24 * 60 * 60 * 1000);
  const fmt = (d) => d.toLocaleDateString('pt-BR');
  return {
    'lead.nome': t('proposalSettings.preview.sampleLeadName', 'Reforma da loja – Centro'),
    'lead.valor': 'R$ 24.500,00',
    'contato.nome': t('proposalSettings.preview.sampleContactName', 'Maria Souza'),
    'contato.email': 'maria.souza@cliente.com.br',
    'contato.telefone': '(31) 99876-5432',
    'vendedor.nome': t('proposalSettings.preview.sampleSellerName', 'João Pereira'),
    'vendedor.email': 'joao@suaempresa.com.br',
    'vendedor.telefone': '(31) 3333-1010',
    'empresa.nome': nomeEmpresa || t('proposalSettings.preview.sampleCompanyName', 'Sua Empresa'),
    'proposta.numero': '1042',
    'proposta.titulo': t('proposalSettings.preview.sampleProposalTitle', 'Projeto Alfa'),
    'proposta.valor_total': 'R$ 24.500,00',
    'proposta.validade': fmt(validade),
    'proposta.data': fmt(hoje),
  };
}

// Espelha resolverVariaveis do backend (propostas.service.js): troca {{chave}}
// pelo valor e apaga a chave quando não existe no contexto.
export function resolverPreview(texto, dados) {
  return String(texto || '').replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_, chave) => dados[chave] ?? '');
}

// Rótulo do grupo na paleta, derivado do prefixo da chave (lead.nome -> lead).
// Função (não objeto) porque os rótulos precisam de `t` para ficar traduzíveis.
export function GRUPOS_VARIAVEIS(t) {
  return {
    proposta: t('proposalSettings.variableGroups.proposta', 'Proposta'),
    empresa: t('proposalSettings.variableGroups.empresa', 'Sua empresa'),
    contato: t('proposalSettings.variableGroups.contato', 'Contato'),
    lead: t('proposalSettings.variableGroups.lead', 'Oportunidade'),
    vendedor: t('proposalSettings.variableGroups.vendedor', 'Vendedor'),
  };
}

// Fallback caso GET /propostas/variaveis falhe — mantém a paleta utilizável.
// Função (não array) porque os labels precisam de `t` para ficar traduzíveis.
export function VARIAVEIS_FALLBACK(t) {
  return [
    { chave: 'contato.nome', label: t('proposalSettings.variableFallback.contatoNome', 'Nome do contato') },
    { chave: 'empresa.nome', label: t('proposalSettings.variableFallback.empresaNome', 'Nome da empresa') },
    { chave: 'proposta.titulo', label: t('proposalSettings.variableFallback.propostaTitulo', 'Título da proposta') },
    { chave: 'proposta.valor_total', label: t('proposalSettings.variableFallback.propostaValorTotal', 'Valor total da proposta') },
    { chave: 'proposta.validade', label: t('proposalSettings.variableFallback.propostaValidade', 'Data de validade') },
    { chave: 'vendedor.nome', label: t('proposalSettings.variableFallback.vendedorNome', 'Nome do vendedor') },
  ];
}
